<template>
<footer :class="$style.footer">
    <footer-nav />
    <download-whale />
</footer>
</template>

<script>
import FooterNav from "./FooterNav.vue";
import DownloadWhale from "./DownloadWhale.vue";

export default {
    components: { FooterNav, DownloadWhale }
};
</script>

<style lang="scss" module>
@use "@/assets/scss/mixins" as m;

.footer {
    @include m.md {
        flex-direction: column;
        text-align: center;
    }
    @include m.m_inner;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
